import { format, getDay } from "date-fns";

const validarHorarioAcesso = (horariosAcesso) => {
  if (!horariosAcesso) return true;
  const agora = new Date();
  const horaAtual = format(agora, "HH:mm");
  const horarioHoje = horariosAcesso.find(
    (horario) => horario.diaSemana === getDay(agora),
  );
  return Boolean(
    horarioHoje &&
    horaAtual >= horarioHoje.entrada &&
    horaAtual < horarioHoje.saida,
  );
};

export default validarHorarioAcesso;
